import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from "../../../environments/environment";
import {authToken, StorageService} from "../storage.service";
import {CustomRangeParam, RangePresetParam} from "../../domain/stats";
import {authHeader, coincidentPeakUrl, loadForecastUrl, probabilityUrl, programUrl} from "../../domain/constants";
import {Program} from "../../domain/cloud-topology";
import {AuthGuardService} from "../auth-guard.service";
import {map} from "rxjs/operators";
const programId = '6a6f5607-434e-4d68-ae54-091a459fde19';

@Injectable({
  providedIn: 'root'
})
export class GaService {
  constructor(private http: HttpClient, private storage: StorageService) { }

  getCoincidentPeak(program?: Program, startDate?: string, stopDate?: string, interval?: string): Observable<any> {
    const params: HttpParams = new HttpParams({
      fromObject: {
        startDate: startDate,
        stopDate: stopDate,
        interval: interval
      }
    });

    return this.http.get(environment.vppUrl + '/' + programUrl + '/' + program.id + '/' + coincidentPeakUrl,
      { params: params}
    ).pipe(map(res => res['data']));
  }
}
